import { Button, Typography, Box, Stack } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function RecoverEmailAccount() {
  const { isMobile } = useIsMobile()
  const lang = useLang()
  const location = useLocation();
  const { name, cellphone, emailResult } = location.state || {};
  
  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 7 }}>
        아이디 찾기
      </Typography>

      <Stack
        spacing={3}
        alignItems="center"
        justifyContent="center"
        sx={{ 
          bgcolor: 'grey.50',
          borderRadius: 4,
          minHeight: '160px',
          py: 3,
          px: 4,
        }}
      >
        {emailResult && emailResult.length > 0 ? (
          <>
            <Typography component="p" sx={{ textAlign: 'center' }}>
              아이디(이메일 주소) {emailResult.length}개를 찾았습니다.<br />
              비밀번호를 잊으셨다면 [비밀번호 찾기]를 이용해 주세요.
            </Typography>
            <Stack
              component="ul"
              spacing={1.5}
              sx={{
                p: 0,
                m: 0,
                listStyle: 'none',
                '& li': {
                  position: 'relative',
                  typography: isMobile ? 'subtitle3' : 'subtitle2',
                  fontWeight: '600',
                  color: 'primary.main',
                  textAlign: 'center'
                },
              }}
            >
              {emailResult.map((item, idx) => (
                 <Typography component="li" key={idx}>
                  {item.memberEmail}{' '}[{item.memberTypeCode == 'INST' ? '기관회원' : '일반회원'}]
                </Typography>
              ))}
            </Stack>
          </>
        ) : (
        <Typography component="p" sx={{ textAlign: 'center' }}>
          일치하는 회원 정보를 찾을 수 없습니다.<br />
          서비스 이용을 위해 [회원가입]을 진행해 주세요.
        </Typography>
        )}
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 5 }}>
        {emailResult && emailResult.length > 0 ? (
          <>
            <Button component={RouterLink} to={buildLangHref('/recoverpassword', lang)} size="large" variant="outlined" sx={{ flex: 1 }}>비밀번호 찾기</Button>
            <Button component={RouterLink} to={buildLangHref('/login', lang)} size="large" variant="contained" sx={{ flex: 1 }}>로그인</Button>
          </>
        ) : (
          <>
            <Button component={RouterLink} to={buildLangHref('/signup', lang)} size="large" variant="outlined" sx={{ flex: 1 }}>회원가입</Button>
            <Button component={RouterLink} to={buildLangHref('/recoveremailaccount', lang)} size="large" variant="contained" sx={{ flex: 1 }}>다시 찾기</Button>
          </>
        )}
      </Stack>
      
    </Box>
  )
}